export default {
  ОбучениеЛично: 1,
  ЛечениеДорогост: 2,
  СтраховДобров: 3,
  ОценкаКвалиф: 4,
  Строительство: 5,
  ОбучениеРебенка: 1,
  СтраховПенсНак: 3,
  Лечение: 2,
  СтраховПенсЖизни: 3,
};
